import { Property } from "../../api/Property";
import { RoutedViewProps } from "@my-dld/utils/UrlUtils";
import React, { Component } from "react";
import { PropertiesResponse, RVEnvironment, RVPropertyType, RVPropView, SearchOption } from "../../api/entities";
import * as RVApi from "../../api/api";
import { hideLoading, showLoading, showMessage } from "@my-dld/utils/UIUtils";
import RVContext from "../../RVContext";
import Strings from "@my-dld/assets/strings";
import { MetricSystem } from "@my-dld/utils/UnitUtils";
import RVPropertyTable from "./RVPropertyTable";
import { setPropertiesOptions } from "../../RVUtils";
import { replaceNavigate } from "@my-dld/utils/StoreUtils";

interface XProperty extends Property {
	isSelected?: boolean;
}

interface State {
	error?: string;
	ix: number;
	opts: SearchOption;
	env: RVEnvironment;
	properties: XProperty[];
	selected: XProperty[];
	hasMoreData: boolean;
}

class Properties extends Component<RoutedViewProps, State> {
	static contextType = RVContext;
	context!: React.ContextType<typeof RVContext>;
	apiHandler: any;
	apiExHandler: any;

	constructor( props: RoutedViewProps ) {
		super( props );
		const locState = props.location.state;
		this.state = {
			env: locState && locState.env ? locState.env : undefined,
			opts: locState && locState.opts ? locState.opts : undefined,
			ix: 0,
			properties: [],
			selected: [],
			hasMoreData: false,
		};
	}

	loadProperties = () => {
		let isLoadMore = false;
		if ( this.state.properties.length > 0 )
			isLoadMore = true;
		showLoading();
		this.apiHandler = ( apiResponse: PropertiesResponse ) => {
			if ( apiResponse ) {
				let properties: XProperty[] = apiResponse.PropertiesList ? apiResponse.PropertiesList : [];
				let savedProps = this.context.properties!;
				if ( savedProps == undefined ) savedProps = [];
				let hasMoreDate = false;
				if ( properties && properties.length > 0 ) {
					hasMoreDate = ( properties[ properties.length - 1 ].MoreData === "True" );
				}
				const cs = this.state.selected;
				if ( savedProps && savedProps.length > 0 ) {
					properties.forEach( p => {
						let isSelected = savedProps.find( ( x: Property ) => ( x.PropertyTypeId === p.PropertyTypeId && x.PropertyId === p.PropertyId ) ) != undefined;
						p.isSelected = isSelected;
						if ( isSelected ) {
							cs.push( p );
						}
					} );
				}

				const pl = [
					...this.state.properties,
					...properties,
				];
				hideLoading();
				this.setState( {
					properties: pl,
					hasMoreData: hasMoreDate,
					selected: cs,
				} );
			}
		};
		this.apiExHandler = ( reason: any ) => {
			hideLoading();
			this.setState( {
				hasMoreData: false,
			} );
			if ( reason && reason.type && reason.type === "ValidationError" ) {
				if ( isLoadMore && reason.codes && reason.codes.length === 1 && reason.codes[ 0 ].Identity === 2 ) {
					this.setState( {
						hasMoreData: false,
					} );
				} else
					this.setState( {
						error: reason.message,
					} );
			} else {
				showMessage( reason.toString() );
			}
		};
		const request = { ...this.state.opts };
		request.startIndex = this.state.ix;
		RVApi.searchProperties( request )
		.then( RVApi.validateResponse )
		.then( this.apiHandler )
		.catch( this.apiExHandler );
	};

	clearAll = () => {
		this.setState( {
			selected: [],
			properties: this.state.properties.map( p => {
				p.isSelected = false;
				return p;
			} ),
		} );
	};

	componentDidMount(): void {
		this.loadProperties();
	}

	render() {
		const { properties, selected, env } = this.state;
		return <React.Fragment>
			{
				selected && selected.length === 0 &&
				<div className="alert alert-info">
					<span> { Strings.select_properties_for_valuation } </span>
				</div>
			}
			{
				properties && properties.length > 0 &&
				<React.Fragment>
					{
						selected && selected.length > 0 && <div className="alert alert-info">
							<span> { `${ selected.length }  ${ selected.length > 1 ? Strings.properties_selected : Strings.property_selected } ` } </span>
						</div>
					}
					<RVPropertyTable
						key={ "-lnd" } type={ env.propertyType! }
						properties={ properties } unit={ MetricSystem } onSelect={ this.onSelectProperty } view_type={ RVPropView.Tabu_Properties }/>
				</React.Fragment>
			}
			<div className="enoc-add-buyer">
				<button
					className="btn btn-grey btn_style1 me-2" data-bs-target="#completedProjectsModal"
					onClick={ () => {
						this.clearAll();
					} }
					data-bs-toggle="modal" type="button">{ Strings.clear_all }
				</button>
				<button
					className="btn btn_1 btn_style1 btn-sm" data-bs-target="#completedProjectsModal"
					onClick={ this.onProceed }
					data-bs-toggle="modal" type="button">{ Strings.proceed }
				</button>
			</div>
		</React.Fragment>;
	}

	onProceed = () => {
		let savedProps = this.context.properties;
		if ( savedProps == undefined ) savedProps = [];
		let properties: Property[] = [
			...savedProps,
			...this.state.selected ];
		properties = Array.from( new Set( properties.map( p => {
			return p.PropertyTypeId + "/" + p.PropertyId;
		} ) ) ).map( p => {
			return properties.find( x => ( x.PropertyTypeId + "/" + x.PropertyId ) === p )!;
		} );
		setPropertiesOptions( properties, this.state.opts, this.state.env );
		replaceNavigate( "/mydld/rentalvaluation/rvproperties" );
	};

	onSelectProperty = ( property: XProperty ) => {
		let isInSelected = property.isSelected === true;
		const { selected } = this.state;
		if ( isInSelected ) {
			let newSel = selected.filter( x => !( x.PropertyTypeId === property.PropertyTypeId && x.PropertyId === property.PropertyId ) );
			this.setState( {
				selected: newSel,
			} );
			property.isSelected = !isInSelected;
		} else {
			let isValid = this.isValidForAdding( property, this.state.selected );
			if ( isValid ) {
				let newSel = [ ...selected, property ];
				this.setState( {
					selected: newSel,
				} );
				property.isSelected = !isInSelected;
			} else {
				let message = Strings.rv_property_cannot_added;
				const pt = property.PropertyTypeId;
				switch ( pt ) {
					case RVPropertyType.LAND:
						message = message + "\n" + Strings.rv_property_cannot_added_land;
						break;
					case RVPropertyType.VILLA:
						message = message + "\n" + Strings.rv_property_cannot_added_villa;
						break;
					case RVPropertyType.UNIT:
						message = message + "\n" + Strings.rv_property_cannot_added_unit;
						break;
					case RVPropertyType.BUILDING:
						message = message + "\n" + Strings.rv_property_cannot_added_building;
						break;
					default:
						break;
				}
				showMessage( message );
			}

		}
	};

	isValidForAdding = ( property: XProperty, currentProps: XProperty[] ) => {
		const properties: XProperty[] = [];
		let savedProps = this.context.properties!;
		if ( savedProps && savedProps.length > 0 ) {
			properties.push( ...savedProps );
		}
		if ( currentProps && currentProps.length > 0 ) {
			properties.push( ...currentProps );
		}
		if ( properties && properties.length > 0 ) {
			let sp: Property = properties[ 0 ];
			let spType = sp.PropertyTypeId;
			if ( property.PropertyTypeId !== sp.PropertyTypeId ) return false;
			let isValid = true;
			switch ( spType ) {
				case RVPropertyType.LAND:
					isValid = sp.LandAreaId === property.LandAreaId;
					break;
				case RVPropertyType.VILLA:
					isValid = sp.LandNo === property.LandNo;
					isValid = isValid && sp.LandSubNo === property.LandSubNo;
					isValid = isValid && sp.LandAreaId === property.LandAreaId;
					break;
				case RVPropertyType.UNIT:
					isValid = sp.BuildingPropertyId === property.BuildingPropertyId;
					isValid = isValid && sp.LandNo === property.LandNo;
					isValid = isValid && sp.LandSubNo === property.LandSubNo;
					isValid = isValid && sp.LandAreaId === property.LandAreaId;
					break;
				case RVPropertyType.BUILDING:
					break;
				default:
					break;
			}
			return isValid;
		}
		return true;
	};
}

export default Properties;
